import axios from "axios";

function api() {
	// 創建axios
	const API_URL = process.env.REACT_APP_API_URL;
	const instance = axios.create({
		baseURL: API_URL,
	});

	// 設置攔截
	const setupInterceptors = () => {
		// 請求攔截器
		instance.interceptors.request.use(
			(config) => {
				// 在每次請求中帶上token
				const token = localStorage.getItem("api_token");
				if (token) {
					config.headers["Authorization"] = `Bearer ${token}`;
				}

				return config;
			},
			(error) => {
				// Do something with request error
				return Promise.reject(error);
			},
		);

		// 回應攔截器
		instance.interceptors.response.use(
			(res) => {
				// Do something with response data
				return res.data;
			},
			(error) => {
				return Promise.reject(error);
			},
		);
	};

	setupInterceptors();

	return instance;
}

export default api();
